export function memberInitials({ firstName, lastName }: { firstName?: string; lastName?: string }) {
  const fn = firstName ?? '';
  const ln = lastName ?? '';
  return fn.length > 0 && ln.length > 0 ? `${fn[0]}${ln[0]}` : undefined;
}
